<script>
import DialogBody from "../../dialog/components/dialog-body.vue";
import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
import Loading from "../../common/loading.vue";
import DialogHeader from "../../dialog/components/dialog-header.vue";
import DialogBase from "../../dialog/components/dialog-base.vue";
import TextField from "../../common/text-field.vue";
import toaster from "../../common/toaster";
import SelectField from "../../common/select-field.vue";
import {
    dateTodayUS,
    FormatJsDateTimeToLocaleString,
    validityDateToJsDate
} from "../../../../utils/date";
import ScreenshotCarousel from "./screenshot-carousel.vue";
import ScreenshotActionbar from "./screenshot-actionbar.vue";
import moment from "moment/moment";

const FETCH_LIMIT = 10;

    export default {
        name: "screenshotDialog",
        components: {
            ScreenshotActionbar,
            ScreenshotCarousel,
            SelectField, TextField, DialogBase, DialogHeader, Loading, DialogActionbar, DialogBody},
        data() {
            return {
                showDialog: false,
                loading: false,
                name: undefined,
                date: dateTodayUS(),
                time: moment().format('HH:mm'),
                data: {},
                screenshots: [],
                selectedScreenshotIndex: 0
            }
        },
        computed: {
            translations() {
                return {
                    title: Lang.langGet("Screenshot History for \":name\"", {name: this.data.name}),
                    search: Lang.langGet("Search"),
                    screenshotTaken: Lang.langGet("Screenshot captured"),
                    loadError: Lang.langGet("Cannot load screenshots.")
                }
            },
            maxDate() {
                return dateTodayUS();
            },
        },
        methods: {
            show() { this.showDialog = true; },
            hide() { this.showDialog = false; },
            handleClose() {
                this.screenshots = [];
                this.hide();
            },
            loadScreenshots: function (searchType = 'full', dontMoveIndex = false) {
                if(this.loading) return;

                this.loading = true;
                this.noData = false;

                axios.post('/system/client-screenshots/get', {
                    project_id: Laravel.activeProject,
                    filter_id: this.data.id,
                    search_date: this.date,
                    search_time: this.time,
                    limit: FETCH_LIMIT,
                    offset: (searchType !== 'full') ? this.screenshots.length : 0,
                    type: searchType,
                }).then((response) => {
                    this.loading = false;

                    if (response.data.data.data.length === 0) {
                        return;
                    }

                    const oldScreenshotLength = this.screenshots.length;
                    const newScreenshots = this.getScreenshotsFromResponse(searchType, response);

                    this.screenshots = newScreenshots;

                    if (!dontMoveIndex) {
                        if ((response.data.data.index) && (response.data.data.index>= 0)) {
                            this.selectedScreenshotIndex = this.screenshots.length- response.data.data.index- 1;
                        } else {
                            this.selectedScreenshotIndex = this.screenshots.length - 1;
                        }
                    } else {
                        if (searchType === 'past') {
                            this.selectedScreenshotIndex = this.screenshots.length - oldScreenshotLength;
                        }
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    this.loading = false;
                    toaster.error(this.translations.loadError);
                });
            },
            getScreenshotsFromResponse(searchType, response) {
                var fetched = response.data.data.data.reverse();

                _.forEach(fetched, function(entry) {
                    entry.date_js = validityDateToJsDate(entry.mms_timezone_date);
                    entry.date_local = FormatJsDateTimeToLocaleString(entry.date_js);
                });

                if(searchType === 'future') {
                    return this.screenshots.concat(fetched);
                }

                if(searchType === 'past') {
                    return fetched.concat(this.screenshots);
                }

                if (searchType === 'full') {
                    return fetched;
                }
            },
            forward(step = 1) {
                if (step === 0) {
                    var mDate = moment(this.screenshots[this.selectedScreenshotIndex].date_js);
                    this.date = mDate.format('MM/DD/YYYY');
                    this.time = mDate.format('HH:mm');
                } else {
                    if ((this.selectedScreenshotIndex + step) >= this.screenshots.length) return;
                    if (this.selectedScreenshotIndex + step === this.screenshots.length - 1) {
                        this.loadScreenshots('future', true);
                    }
                    this.selectedScreenshotIndex = this.selectedScreenshotIndex + step;
                }
            },
            backward(step = 1) {
                if ((this.selectedScreenshotIndex - step) < 0) return;
                if (this.selectedScreenshotIndex - step === 0) {
                    this.loadScreenshots('past', true);
                }
                this.selectedScreenshotIndex = this.selectedScreenshotIndex - step;
            },
            resetDateAndTime() {
                this.date = dateTodayUS();
                this.time= (moment().format('HH:mm'));
            }
        },
        mounted: function () {
            EaseEventBus.listen('screenshotDialogShow', data => {
                this.data = data;
                this.resetDateAndTime();
                this.loadScreenshots('full');
                this.show();
            });
        }
    }
</script>

<template>
    <dialog-base
        :maxWidth="960"
        @close="handleClose"
        :showDialog="showDialog"
    >
        <dialog-header
            @close="handleClose"
            :title="translations.title"
        />
        <loading :loading="loading"/>
        <dialog-body :minHeight="400">
            <screenshot-actionbar v-if="!loading"
                :time="time"
                :date="date"
                @dateChange="val => date = val"
                @timeChange="val => time = val"
                @search="loadScreenshots('full')"
                @reset="resetDateAndTime"
            />
            <screenshot-carousel v-if="!loading"
                :screenshots="screenshots"
                :index="selectedScreenshotIndex"
                @forward="forward($event)"
                @backward="backward($event)"
            />
        </dialog-body>
    </dialog-base>
</template>
